// Module
var code = "<div v-if=\"contactType\" class=\"c-contact-type__outer\" :class=\"useColor? '': 'outlined'\" :style=\"{ backgroundColor: fillColor, color: textColor }\"> <div class=\"c-contact-type\"> <div v-if=\"useColor && viewMode == 'point'\" class=\"c-contact-type__color\" :style=\"{ backgroundColor: color }\"></div> <div>{{name}}</div> </div> </div> ";
// Exports
export default code;